import React, {useState} from 'react';
import Modal from "../../components/modal/modal";
import axiosInstance from "../../AxiosInstance";
import {BigTextInput, DangerButton, FileInput, SelectInput} from "../../components/input/inputs";
import styles from "../../styles/main.module.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSave} from "@fortawesome/free-solid-svg-icons";
import {
    afterInvoiceActionSuccess,
    rejectFailedResponse,
} from "../bus/afterInvoiceActionSuccess";

export default function CorrectionModal({show, setter, invoice}) {
    const [form, setForm] = useState({});
    const options = [
        {id: 0, name: 'Guía de Remisión'},
        {id: 1, name: "Acta de Conformidad"},
        {id: 2, name: "Informe de servicio"},
        {id: 3, name: "Nota de Credito"}
    ];

    const correct = () => {
        let formData = new FormData();
        for (const key in form) {
            if (key === 'correction') {
                // If the key is 'observation', it's an array of files
                const files = form[key];
                for (let i = 0; i < files.length; i++) {
                    formData.append(key, files[i]);
                }
            } else {
                formData.append(key, form[key]);
            }
        }
        formData.append("bill_id", invoice.id);

        axiosInstance.post('correction/', formData).then(rejectFailedResponse).then(() => {
            afterInvoiceActionSuccess(setter);
        });
    }

    return (
        <Modal show={show} setter={setter} name={'Subsanar'} hideClose={true} size={'m'}>
            <div className={'d-flex justify-content-between align-items-center'}>
                <div>Tipo Doc. a Reemplazar:</div>
                <div style={{flexBasis: '50%'}}>
                    <SelectInput greyBackground={true} form={form} setForm={setForm} hideName={true}
                                 name={'Tipo Doc. a Reemplazar:'} internalName={'document_type'}
                                 options={options}/>
                </div>
            </div>

            <div className={'d-flex justify-content-between align-items-center mt-3 mb-4'}>
                <div>Nro. Doc. Subsanado:</div>
                <div style={{flexBasis: '50%'}}>
                    <div className={'px-2'} style={{
                        borderRadius: '6px',
                        backgroundColor: '#ddd'
                    }}>-
                    </div>
                </div>
            </div>

            <FileInput form={form} setForm={setForm} name={'Seleccionar archivo PDF'} accept={'.pdf'}
                       onChange={(event) => {
                           setForm({
                               ...form,
                               "pdf": event.target.files[0]
                           });
                       }}/>

            <FileInput form={form} setForm={setForm} name={'Seleccionar archivo XML'} accept={'.xml'}
                       onChange={(event) => {
                           setForm({
                               ...form,
                               "xml": event.target.files[0]
                           });
                       }}/>

            <FileInput form={form} setForm={setForm} name={'Otros Archivos (*.pdf, *.zip)'} accept={'.*'}
                       onChange={(event) => {
                           const selectedFiles = Array.from(event.target.files);
                           setForm({
                               ...form,
                               "correction": selectedFiles
                           });
                       }}/>

            <BigTextInput form={form} setForm={setForm} name={'Ingresar Observaciones:'} internalName={'text'}/>

            <div className={'d-flex justify-content-center align-items-center align-content-center mt-3'}>
                <div onClick={() => correct()} className={styles.modalButton} style={{backgroundColor: "#4A4DBB"}}>
                    <FontAwesomeIcon icon={faSave} className={'pe-2'}/> Guardar
                </div>
                <DangerButton onClick={() => setter(false)} name={'Cerrar'}/>
            </div>
        </Modal>
    )
}
